<script setup lang="ts">
import { formatCurrency } from '@consumer/utils/currency'
import type { ReactiveVariable } from '@vue-macros/reactivity-transform/macros'

const {
  amount,
  selectedAmount,
} = defineProps<{
  amount: number
  selectedAmount: ReactiveVariable<number> | undefined
}>()

interface Emit {
  (e: 'selectAmount', amount: number): void
}

const emit = defineEmits<Emit>()

</script>
<template>
  <GButton
    :key="amount"
    name="amount-button"
    size="small"
    secondary
    class="w-full !text-lg transition-all ease-in-out duration-200 !rounded-v2sm
        hover:border-2 !hover:border-primary-base !hover:bg-primary-pale border-solid"
    :class="[
      selectedAmount === amount ?
        '!border-primary-base !bg-primary-pale' :
        '!bg-grey-200 !text-grey-500 !border-grey-400',
    ]"
    @click="emit('selectAmount', amount)"
  >
    {{ formatCurrency(amount) }}
  </GButton>
</template>
